import React, { useState } from 'react';
const faqs = [{
  q: '¿Sirve para Reformer y Mat?',
  a: 'Sí, el MegaPack incluye tomos específicos tanto para Reformer como para Mat Pilates con accesorios (bandas, pelotas, magic circle y más).'
}, {
  q: '¿Los 6 bonos están incluidos en el precio?',
  a: 'Sí, todos los bonos estratégicos están incluidos sin costo adicional en esta oferta de lanzamiento.'
}, {
  q: '¿Qué pasa con alumnas de distintos niveles?',
  a: 'Las clases están diseñadas con progresiones claras desde nivel inicial hasta avanzado, con variantes y regresiones para que adaptes cada bloque a tu alumna.'
}, {
  q: '¿Tiene garantía de devolución?',
  a: 'Sí, tienes 7 días de garantía total. Si no te sirve, te devolvemos el 100% de tu dinero sin preguntas y sin trámites complicados.'
}, {
  q: '¿Cómo recibo el material después de comprar?',
  a: 'El acceso es inmediato. Apenas confirmás el pago, recibís un email con tu enlace de descarga y podés empezar a usar el kit en menos de 5 minutos, desde tablet, móvil o PC.'
}, {
  q: '¿Sirve si recién empiezo como instructora?',
  a: '¡Por supuesto! El kit está pensado tanto para instructoras nuevas que necesitan estructura, como para profesionales con años de experiencia que buscan optimizar su tiempo y refrescar su material.'
}, {
  q: '¿En qué formato vienen los archivos?',
  a: 'Todo el material viene en PDF de alta calidad, optimizado para visualizar en tablet, móvil y PC, o para imprimir si preferís llevarlo en papel al studio. No necesitas ningún software especial.'
}, {
  q: '¿Puedo usarlo con clases presenciales y online?',
  a: 'Sí. Las rutinas y planificaciones funcionan perfectamente para clases presenciales 1 a 1, grupales en studio y también para clases online por Zoom o video. Vos elegís el formato.'
}, {
  q: '¿Cuánto tiempo tengo acceso al material?',
  a: 'Acceso de por vida. Una vez que lo descargás, el kit es 100% tuyo para siempre — sin suscripciones, sin pagos recurrentes, sin fechas de vencimiento.'
}, {
  q: '¿Cómo puedo pagar? ¿Es seguro?',
  a: 'Aceptamos tarjetas de crédito, débito y métodos locales según tu país. El pago se procesa en tu moneda local a través de una pasarela 100% segura y encriptada. Tus datos nunca se comparten.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full bg-bg-main py-24 px-4" data-id="element-105">
      <div className="max-w-3xl mx-auto" data-id="element-106">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-12 tracking-tight" data-id="element-107">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4 mb-16" data-id="element-108">
          {faqs.map((faq, i) => {
          const isOpen = openIndex === i;
          return <div key={i} className={`bg-bg-alt border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'border-primary/50 shadow-[0_0_20px_rgba(168,85,247,0.1)]' : 'border-border-light hover:border-white/20'}`} data-id="element-109">
                <button className="w-full text-left px-6 py-5 flex items-center justify-between gap-4" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} data-id="element-110">
                  <span className={`font-bold text-lg transition-colors ${isOpen ? 'text-primary' : 'text-text-main'}`} data-id="element-111">
                    {faq.q}
                  </span>
                  <span className={`text-2xl flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-45 text-primary' : 'text-text-sec'}`} data-id="element-112">
                    +
                  </span>
                </button>
                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${isOpen ? 'max-h-72 pb-6 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-113">
                  <p className="text-text-sec text-base leading-relaxed" data-id="element-114">
                    {faq.a}
                  </p>
                </div>
              </div>;
        })}
        </div>

        {/* Final CTA */}
        <div className="text-center relative" data-id="element-115">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full h-full bg-cta-green/20 blur-[80px] pointer-events-none rounded-full" aria-hidden="true" data-id="element-116"></div>
          <a href="#pricing" className="relative btn-primary-pulse bg-cta-green font-black text-lg sm:text-2xl px-8 sm:px-12 py-4 sm:py-5 rounded-2xl hover:bg-cta-green-hover transition-all inline-block mb-4 w-full sm:w-auto max-w-2xl text-white shadow-[0_0_30px_rgba(16,185,129,0.3)] border border-white/20" data-id="element-117">
            🚀 ¡SÍ! QUIERO MEJORAR MI CARRERA AHORA
          </a>
          <p className="text-text-sec text-sm font-medium flex items-center justify-center gap-2" data-id="element-118">
            <span data-id="element-119">⚡ Acceso Inmediato</span>
            <span data-id="element-120">•</span>
            <span data-id="element-121">🛡️ Garantía de 7 Días</span>
          </p>
        </div>
      </div>
    </section>;
}